import type { HeadCell } from 'Components/EnhancedTableHead/EnhancedTableHead'
import { WithLoader } from 'Components/WithLoader'
import BulkTicketSaleBatchTableRow from 'Services/SalesManagement/Features/TicketSale/Components/BulkTicketSaleBatchTableRow'
import { useGetBulkTicketSaleBatchesQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { t } from 'ttag'

interface BulkTicketSaleBatchDetailsProps {
  bulkSaleId: string
}

export default function BulkTicketSaleBatchDetails({
  bulkSaleId
}: Readonly<BulkTicketSaleBatchDetailsProps>) {
  const { data: batches, isFetching } = useGetBulkTicketSaleBatchesQuery(bulkSaleId)
  const headCells: HeadCell[] = [
    { id: 'created', label: t`Created` },
    { id: 'createdTickets', label: t`Created tickets` },
    { id: 'downloadTickets', label: t`Download tickets` },
    { id: 'cancel', label: t`Cancel` }
  ]

  return (
    <WithLoader loading={isFetching}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table size="small" aria-label={t`Bulk ticket sale batches table`}>
            <TableHead>
              <TableRow>
                {headCells.map(cell => (
                  <TableCell key={cell.id}>{cell.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {batches?.map(row => (
                <BulkTicketSaleBatchTableRow key={row.id} bulkSaleId={bulkSaleId} batch={row} />
              ))}
              {batches?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={headCells.length} align="center">
                    {t`No batches found`}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </WithLoader>
  )
}
